<div class="text-center ">
    <h2  mat-dialog-title>{{ 'com.usafebox.wait.encryption' | translate }}</h2>
</div>
<div fxLayoutAlign="center" class="m-b-20" >
    <img src="assets/loader.gif" alt="homepage" class="image-auto-size" >
</div>

